import { useSelector, useDispatch } from 'react-redux';
import { toggleSideNav } from './toggleSideNav';

import './SideNavToggleButton.css'

export function SideNavToggleButton() {
    let sideNavValue = useSelector((state: any) => state.toggleSideNav.value);
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(toggleSideNav(!sideNavValue))
    }

    return (<>
        <button className="toggle-button" onClick={handleClick}>
            <div className="toggle-button__line"></div>
            <div className="toggle-button__line"></div>
            <div className="toggle-button__line"></div>
        </button>
    </>)
}